import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

const Declined = () => {
    return (
        <Box textAlign='center' p={6} py={10}>
            <Typography variant='h4' color='initial' mb={2} fontWeight={600}>
                Thank You !
            </Typography>
            
        </Box>
    );
};

export default Declined;
